import dompurify from "isomorphic-dompurify";

import { AlertBanner } from "@jti/core-components";

const { sanitize } = dompurify;

export interface TradeInEligibilityBannerProps {
  title?: string;
  description?: string;
}

export const TradeInEligibilityBanner: React.FC<TradeInEligibilityBannerProps> = ({ title, description }) => (
  <AlertBanner
    tone="warning"
    title={title}
    richDescription={
      description && <div dangerouslySetInnerHTML={{ __html: sanitize(description, { ADD_ATTR: ["target"] }) }} />
    }
  />
);
